import { useState, useCallback } from 'react';
import RankingTab from '@/components/dashboard/RankingTab.tsx';
import MemberDetail from '@/components/admin/MemberDetail.tsx';
import type { User } from '@/types/auth.ts';
import type { SalespersonStats } from '@/types/session.ts';

interface SelectedMemberInfo {
  user: User;
  stats?: SalespersonStats;
}

export default function AdminRankingPage() {
  const [selectedMember, setSelectedMember] = useState<SelectedMemberInfo | null>(null);

  const handleSelectMember = useCallback((member: SalespersonStats) => {
    // Construir un User mínimo a partir de los datos del SalespersonStats.
    // MemberDetail necesita firstName/lastName para renderizar; antes recibía
    // sólo el id y todos los demás campos undefined.
    const user: User = {
      id: member.userId,
      firstName: member.firstName,
      lastName: member.lastName,
      email: '',
      role: 'Salesperson',
    } as User;
    setSelectedMember({ user, stats: member });
  }, []);

  if (selectedMember) {
    return (
      <div key={selectedMember.user.id} className="animate-fade-in">
        <MemberDetail
          member={selectedMember.user}
          memberStats={selectedMember.stats}
          onBack={() => setSelectedMember(null)}
        />
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      <RankingTab onSelectMember={handleSelectMember} />
    </div>
  );
}
